import {InvalidTokenError} from '@packages/utils';
import {parseCookies} from 'nookies';
import {type FC, useState} from 'react';
import type {ColumnCardProps} from '.';
import {
  deleteColumnMyClips,
  updateColumnMyClips,
} from '../../../../core/repositories/clipsRepository';
import {useIsSessionExpired} from '../../../../core/usecases/auth/useIsSessionExpired';
import {ColumnCardPresentation} from './presentation';

export const ColumnCardContainer: FC<ColumnCardProps> = ({
  post,
  isSponsored,
  className,
}) => {
  const [isFavorite, setIsFavorite] = useState(post.favorited);
  const [favoriteCount, setFavoriteCount] = useState<number>(
    post.favoriteCount,
  );
  const {updateIsSessionExpired} = useIsSessionExpired();

  const deleteColumnUseCase = async () => {
    const cookies = parseCookies();
    const result = await deleteColumnMyClips({
      cookies,
      columnId: post.id,
    });
    if (!result.ok && result.error === InvalidTokenError) {
      updateIsSessionExpired(true);
    }

    if (!result.ok) {
      return;
    }

    setIsFavorite(false);
    setFavoriteCount((prev) => Math.max(prev - 1, 0));
  };

  const updateColumnUseCase = async () => {
    const cookies = parseCookies();
    const result = await updateColumnMyClips({
      cookies,
      columnId: post.id,
    });
    if (!result.ok && result.error === InvalidTokenError) {
      updateIsSessionExpired(true);
    }

    if (!result.ok) {
      return;
    }

    setIsFavorite(true);
    setFavoriteCount((prev) => prev + 1);
  };

  const handleClip = async () => {
    if (isFavorite) {
      await deleteColumnUseCase();
      return;
    }

    await updateColumnUseCase();
  };

  return (
    <ColumnCardPresentation
      post={post}
      isSponsored={isSponsored}
      isFavorite={isFavorite}
      favoriteCount={favoriteCount}
      handleClip={handleClip}
      className={className}
    />
  );
};
